import React, { FC } from 'react'

import s from './index.scss'
import WixStudioLogo from './logo.svg'

export const EnterpriseLayout: FC = ({ children }) => {
  return (
    <div className={s.EnterpriseLayout}>
      <div className={s.EnterpriseLayout__header}>
        <WixStudioLogo height={24} width={100} />
      </div>
      <div className={s.EnterpriseLayout__content}>{children}</div>
    </div>
  )
}
